import React, { ReactElement } from 'react';

import {
  QuestionDataType,
  QuestionMetaPropType,
} from '@/modules/types/question';

import Question from '@/components/Player/Question';
import HowlerAudioPlayer from '@/components/AudioPlayer/Howler';
// @todo Need to update quizMeta type to quizMeta instead of QuestionMetaPropType
interface QuizViewType {
  question: undefined | QuestionDataType;
  quizMeta: QuestionMetaPropType;
  handler: any;
}

const QuizView = ({
  question,
  quizMeta,
  handler,
}: QuizViewType): ReactElement => (
  <div id="Quiz">
    <div id="page" className="test-content">
      {question && (
        <>
          <HowlerAudioPlayer />
          <Question question={question} handler={handler} meta={quizMeta} />
        </>
      )}
      <div id="next-content" />
    </div>
  </div>
);

export default QuizView;
